import React from 'react';
import { FormControl, FormLabel, Grid } from '@material-ui/core';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { useForm, Controller } from 'react-hook-form';
import { TextField, Button } from '@mui/material';
import { IFormStep } from '../finalSessionCoacingSurvey.interface';
import { updateAction } from '../actions';
import api from '../../../../services/api';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TaskType } from '../../../../enums/enums';

interface IFormStepExtended extends IFormStep {
  userId: string;
  taskId: string;
  groupId: string;
}

export const Section13: React.FC<IFormStepExtended> = ({ step, setStep, userId, taskId, groupId }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });

  const history = useHistory();

  const { handleSubmit, getValues, control } = useForm({
    defaultValues: state.finalSessionCoachingSurvey.formData as any
  });

  const classes = useStyles();

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ finalSessionCoachingSurvey: { formData: partialData } } as any);
    setStep(step - 1);
  };

  const handleComplete = (data): void => {
    const formData = data;
    const payload = {
      userId: userId,
      taskId: taskId,
      groupId: groupId,
      taskName: TaskType.FinalGroupAssessment,
      formResponse: formData
    };
    const url = '/tasks/response';
    api
      .post(url, payload)
      .then(() => toast.success('Thank you for submitting your Final Assessment'))
      .catch(() => toast.error('Error submitting Final Assessment'))
      .finally(() => history.push('/tasks'));

    actions.updateAction({
      finalSessionCoachingSurvey: {
        formData: null
      }
    } as any);
  };

  const onSubmit = (data: any): void => {
    console.log('Final FormData: ', data);
    actions.updateAction({
      finalSessionCoachingSurvey: {
        formData: {
          ...data
        }
      }
    } as any);

    handleComplete(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid className={classes.formContent} container spacing={5} alignItems="center" justifyContent="center">
        <Grid container item xs={12} direction="column">
          <FormControl>
            <FormLabel className={classes.formLabel}>Do you have any feedback on the Portal?</FormLabel>
            <Controller
              render={({ field }) => (
                <TextField
                  multiline
                  rows={4}
                  placeholder="Type your answer here..."
                  color="success"
                  fullWidth
                  {...field}
                  sx={{ mb: 4 }}
                />
              )}
              name="portalImprovement"
              control={control}
            />
          </FormControl>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
            BACK
          </Button>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="contained" color="success" type="submit">
            SUBMIT
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
